import React, { useState } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import "../index.css";

function Header() {
  const [isOpen, setIsOpen] = useState(false); // State to control the navbar collapse

  // Function to toggle collapse
  const toggleNavbar = () => setIsOpen(!isOpen);

  return (
    <Navbar bg="light" variant="light" expand="lg" fixed="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            alt="VarayQcServices"
            src="/images/VARAY with out bg.png"
            width="100"
            height="65"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>

        {/* Navbar Toggle */}
        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={toggleNavbar}
          className="custom-navbar-toggle"
        />

        <Navbar.Collapse id="navbar-nav" in={isOpen}>
          <Nav className="ms-auto d-flex align-items-center">
            <Nav.Link
              as={Link}
              to="/"
              className="header-link"
              onClick={() => setIsOpen(false)} // Close navbar on click
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/about"
              className="header-link"
              onClick={() => setIsOpen(false)} // Close navbar on click
            >
              About Us
            </Nav.Link>

            {/* Services Dropdown */}
            <NavDropdown title="Services" id="services-dropdown">
              {/* <NavDropdown.Item
                as={Link}
                to="/services/product-sourcing"
                onClick={() => setIsOpen(false)}
              >
                Product Sourcing
              </NavDropdown.Item> */}

              <NavDropdown.Item
                as={Link}
                to="/services/supplier-verification"
                onClick={() => setIsOpen(false)}
              >
                Supplier Verification
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/services/quality-assurance"
                onClick={() => setIsOpen(false)}
              >
                Quality Assurance
              </NavDropdown.Item>
            </NavDropdown>

            {/* Information Dropdown */}
            <NavDropdown title="Information" id="information-dropdown">
              <NavDropdown.Item
                as={Link}
                to="/information/Packing Details"
                onClick={() => setIsOpen(false)}
              >
                Packing Details
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/information/Tiles - Classification"
                onClick={() => setIsOpen(false)}
              >
                Tiles Classification
              </NavDropdown.Item>
            </NavDropdown>

            {/* Other Links */}
            <Nav.Link
              as={Link}
              to="/faq"
              className="header-link"
              onClick={() => setIsOpen(false)} // Close navbar on click
            >
              FAQ
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/contact"
              className="header-link"
              onClick={() => setIsOpen(false)} // Close navbar on click
            >
              Contact Us
            </Nav.Link>

            {/* Social Icons */}
            <Nav.Link
              href="https://www.instagram.com/varay_qc_services/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                size="2x"
                className="header-icon"
              />
            </Nav.Link>

            <Nav.Link
              href="https://wa.me/919016972420"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faWhatsapp}
                size="2x"
                className="header-icon"
              />
            </Nav.Link>

            <Nav.Link href="tel:+919016972420">
              <FontAwesomeIcon
                icon={faHeadset}
                size="2x"
                className="header-icon"
              />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
